import { ComponentBase } from 'utils/abstract-classes/component-base'
import { CarComparisonStore } from '../store'
import { ATTR_NAME } from 'constants/attr-name'
import { EventType } from 'constants/enums'

const { driving: attrName } = ATTR_NAME
export class ComparisonResults extends ComponentBase {
    public static pageUrl = '/comparison-results'
    private scrollPanels: HTMLDivElement[]

    public constructor() {
        super()

        const resultUrl = CarComparisonStore.getInstance().buildPath()
        const url: URL = new URL(window.location.href)

        // reload full path url based on vehicle data in session if the page url path is only default path with session
        if (
            url.pathname === `${ComparisonResults.pageUrl}/` &&
            resultUrl !== `${ComparisonResults.pageUrl}/`
        ) {
            window.location.assign(resultUrl)
        }

        if (!this.initHTMLElements()) {
            return
        }

        this.scrollPanels.forEach((elem) => {
            elem.addEventListener(EventType.SCROLL, () => {
                this.moveScrollPanels(elem.scrollLeft)
            })
        })
    }

    /**
     * Initialize HTML DOMs
     *
     * @returns {boolean} indicates mandatory DOMs exist
     */
    private initHTMLElements(): boolean {
        const scrollPanels = this.getElements<HTMLDivElement>(
            `[${attrName.comparisonResults.scrollPanel}]`
        )

        if (!scrollPanels) {
            return false
        }

        this.scrollPanels = scrollPanels

        return true
    }

    /**
     * move scrollPanels left and right in sync
     *
     * @param {pos} scroll distances from left and right
     */
    private moveScrollPanels(pos: number): void {
        this.scrollPanels.forEach((item) => {
            item.scrollTo(pos, 0)
        })
    }
}
